import { useState } from "react";

import { ScheduleDeviceNode } from "../../../types/types";
import { useTranslation } from "react-i18next";
import { TimeRangeModal } from "./TimeRangeModal";
import { PortalModal } from "../../PortalModal/PortalModal";
import { NodeBoxButton } from "../../Misc/Buttons/NodeBoxButton";

interface Props {
  node: ScheduleDeviceNode,
  isScheduled: boolean;
}

// Opens modal window for Relay Box quiet time schedule configuration
export function ScheduleButton({
  node,
  isScheduled,
}: Props) {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  return <>
    <NodeBoxButton
      on={isScheduled}
      // timezone is not provided when location is not set
      title={node.timezone ?
        t("Configure time schedule") :
        t("Feature unavailable. Installation is missing geo-location.")
      }
      disabled={!node.timezone}
      onClick={() => setShowModal(true)}
      actionBarStyle
    >
      <i className="fas fa-clock"></i>
      {t("Schedule")}
    </NodeBoxButton>
    <PortalModal
      isOpen={showModal}
      close={() => setShowModal(false)}
    >
      <TimeRangeModal
        node={node}
        close={() => setShowModal(false)}
      />
    </PortalModal>
  </>;
}